import { profile } from '../data/content';
import { DownloadIcon } from './primitives';

export function ResumeBand() {
  return (
    <section className="resume" id="resume" aria-labelledby="resume-title">
      <div className="container">
        <div data-reveal>
          <h2 id="resume-title">Résumé</h2>
          <div className="block" />
          <p>
            One page covering education, experience, and the projects above. Happy to send a version
            tailored to a specific role.
          </p>
          <a className="btn-resume" href={`${import.meta.env.BASE_URL}${profile.resume}`} download>
            <span>Download my résumé</span>
            <DownloadIcon />
          </a>
        </div>
      </div>
    </section>
  );
}
